import api from './api';

const BASE = '/sostenibilidad';

export const sostenibilidadService = {
    huellaCarbono: async (periodo = null) => {
        const params = {};
        if (periodo) params.periodo = periodo;
        const response = await api.get(`${BASE}/huella-carbono`, { params });
        return response.data;
    },

    periodos: async () => {
        const response = await api.get(`${BASE}/periodos`);
        return response.data?.periodos || [];
    },

    recomendacionesIA: async (periodo = null) => {
        const params = {};
        if (periodo) params.periodo = periodo;
        const response = await api.get(`${BASE}/recomendaciones-ia`, { params });
        return response.data;
    },

    intensidad: async (periodo = null) => {
        const params = {};
        if (periodo) params.periodo = periodo;
        const response = await api.get(`${BASE}/intensidad`, { params });
        return response.data;
    },

    listarConfiguracionAlmacenes: async () => {
        const response = await api.get(`${BASE}/configuracion-almacenes`);
        return response.data;
    },

    guardarConfiguracionAlmacen: async (almacen, areaM2, colaboradores) => {
        const response = await api.post(`${BASE}/configuracion-almacenes`, {
            almacen,
            area_m2: areaM2 !== '' && areaM2 != null ? Number(areaM2) : null,
            colaboradores: colaboradores !== '' && colaboradores != null ? parseInt(colaboradores, 10) : null,
        });
        return response.data;
    },
};
